<script setup lang="ts">
defineProps<{
  hasFacebook: boolean | null
  hasInstagram: boolean | null
  hasGoogle: boolean | null
}>()
</script>

<template>
  <div class="flex items-center gap-2">
    <BaseIcon
      name="IconoirFacebook"
      :class="[
        'h-5 w-5 icon-facebook',
        {
          'filter grayscale-75': !hasFacebook
        }
      ]"
    />
    <BaseIcon
      name="IconoirInstagram"
      :class="[
        'h-5 w-5 icon-instagram',
        {
          'filter grayscale-75': !hasInstagram
        }
      ]"
    />
    <BaseIcon
      name="IconoirGoogleCircle"
      :class="[
        'h-5 w-5 icon-google',
        {
          'filter grayscale-75': !hasGoogle
        }
      ]"
    />
  </div>
</template>

<style>
.icon-google {
  color: #db4437;
}
.icon-facebook {
  color: #1877f2;
}
.icon-instagram {
  color: #e4405f;
}
</style>
